/**
 * Created by sk on 2020 1 17.
 */
import axios from 'axios'
import QS from 'qs'

axios.defaults.withCredentials = true;

//添加一个请求拦截器
axios.interceptors.request.use(function (config) {
  // console.dir(config);
  return config;
}, function (error) {
  // Do something with request error
  return Promise.reject(error);
});

// 添加一个响应拦截器
axios.interceptors.response.use(function (response) {
  console.log(response)
  if (response.status === 200) { 
    // if (response.data && response.data.status) {
    //   if (response.data.status !== '0') {
    //     if (response.data.message === "用户未登录") {
    //       new Vue().$emit('goto', '/login')
    //     }
    //   }
    // }           
    return Promise.resolve(response);   
  } else {            
    return Promise.reject(response);    
  }  
}, function (error) {
  console.log(error)
  // Do something with response error
  return Promise.reject(error);
});

//基地址
var base = '';  //接口代理地址参见：config/index.js中的proxyTable配置

// }
//通用方法postJson
export const POSTJSON = (url, params) => {
  return axios.post(`${base}${url}`, params).then(res => res.data)
}

export const POSTFORM = (url, params) => {
  return axios.post(`${base}${url}`, QS.stringify(params), {headers: {'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'}}).then(res => res.data)
}

export const GET = (url, params) => {
  return axios.get(`${base}${url}`, {params: params}).then(res => res.data)
}

export const PUT = (url, params) => {
  return axios.put(`${base}${url}`, params).then(res => res.data)
}

export const DELETE = (url, params) => {
  return axios.delete(`${base}${url}`, {params: params}).then(res => res.data)
}

export const PATCH = (url, params) => {
  return axios.patch(`${base}${url}`, params).then(res => res.data)
}



//////////////////
// WEBPACK FOOTER
// ./~/szyx-axios/index.js
// module id = 107
// module chunks = 4